<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="form-panel__deactivated form-panel">
    <div class="form-panel__deactivated__message panel-content-body">
      <p v-if="formConfig.deactivation_message">
        <template v-if="hasNuxt">
          <client-only>
            <span v-html="formConfig.deactivation_message"></span>
          </client-only>
        </template>
        <span v-else v-html="formConfig.deactivation_message"></span>
      </p>
      <p>{{ $t('action.formDeactivatedThanks', locale) }}</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'PanelDeactivated',
  computed: {
    isClient() {
      return !process.server
    },
    tick1xUrl() {
      return this.getImgUrl('tickPNG1x')
    },
    tick2xUrl() {
      return this.getImgUrl('tickPNG2x')
    },
    tick3xUrl() {
      return this.getImgUrl('tickPNG3x')
    },
    ...mapState('actionForm', ['formConfig', 'locale'])
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_panels-common.scss';
</style>
